import { nestProperties } from './invoice.utils'
import { formatFiToISO } from './DateTimeFormat'
import DateTimeFormat from './DateTimeFormat'
import { arrayToString } from './employer/stringArrayHandle.utils'

export const formatInvoiceFormValues = (
  formValues,
  uuid,
  userType,
  loggedInEmail,
  selectedUser,
  invoice_id,
  registeredUsersList,
  attachments,
  attachedWorkShiftJournalIds,
  attachedJournalPdfData
) => {
  const rows = formValues.rows

  rows[Symbol.iterator] = function* () {
    const keys = Reflect.ownKeys(this)
    for (const key of keys) {
      yield this[key]
    }
  }

  const body = {
    ...formValues,
    uuid: userType == 2 ? selectedUser.uuid : uuid
  }

  body.sended_by = loggedInEmail
  body.userEmail = userType == 2 ? selectedUser.email : loggedInEmail

  body.invoice_lang = formValues.invoice_lang ? 'en' : 'fi'

  let total_sum_noSpace = body.total_sum
    .toString()
    .replace('−', '-')
    .replace(/\s+/g, '')
  body.total_sum = parseFloat(total_sum_noSpace.replace(/,/g, '.'))

  body.instant_payment = formValues.quick_pay ? 'quick_pay' : ''

  // if user selects invoice_reminder (true), invosy is denied payment control (0)
  body.isPaymentControl = formValues.invoice_reminder ? 0 : 1

  body.status = formValues.quick_pay ? 3 : 0

  body.building_service = body.vat_select === 'vat_0_builders' ? true : false

  if (body.invoice_price_selection === false) {
    body.invoice_price_selection = 0
  } else if (body.invoice_price_selection === true) {
    body.invoice_price_selection = 1
  } else {
    body.invoice_price_selection = 0
  }

  let attached_journal_pdf
  if (attachedJournalPdfData !== null && attachedJournalPdfData !== undefined) {
    attached_journal_pdf = {
      filename: formValues.invoice_lang
        ? 'Workshift_Journal_Details.pdf'
        : 'Työvuoron_journalin_tiedot.pdf',
      filetype: 'application/pdf',
      data: attachedJournalPdfData
    }
    attachments.push(attached_journal_pdf)
  }
  body.document = attachments
  body.workshiftjournal = [
    {
      attachedWorkShiftJournalIds:
        attachedWorkShiftJournalIds.length === 0
          ? ''
          : arrayToString(attachedWorkShiftJournalIds)
    }
  ]
  body.agreementDetails = [
    {
      agreementId: formValues.agreementId
    }
  ]

  const filteredBody = []

  let bodyRows = []
  const l = Array.isArray(body.rows)
    ? body.rows.length
    : Object.keys(body.rows).length

  let max_vat_percent = 0

  for (let i = 0; i < l; i++) {
    filteredBody.push({ ...body.rows[i] })
    filteredBody[i].description = filteredBody[i].description
    filteredBody[i].quantity = filteredBody[i].quantity
    filteredBody[i].unit = filteredBody[i].unit
    filteredBody[i].quantity_price = filteredBody[i].quantity_price

    filteredBody[i].sum_tax_free = filteredBody[i].sum_tax_free

    filteredBody[i].vat_percent = filteredBody[i].vat_percent
    max_vat_percent = Math.max(max_vat_percent, filteredBody[i].vat_percent)
    filteredBody[i].vat = filteredBody[i].vat
    filteredBody[i].vat_percent_description =
      filteredBody[i].vat_percent_description
    filteredBody[i].document = filteredBody[i].document

    filteredBody[i].start_date = formatFiToISO(
      new DateTimeFormat('fi', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      })
        .format(filteredBody[i].start_date)
        .split('.')
    )

    filteredBody[i].end_date = formatFiToISO(
      new DateTimeFormat('fi', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      })
        .format(filteredBody[i].end_date)
        .split('.')
    )

    bodyRows[i] = filteredBody[i]
  }

  body.rows = bodyRows

  const groupInvoiceRows = formValues.groupInvoiceRow || []

  const groupBodyRows =
    formValues.groupTotalAmount > 0
      ? groupInvoiceRows.map((groupRow) => {
          const { groupEmail, groupAmount } = groupRow
          const memberValues = calculateMemberValues(
            groupAmount,
            max_vat_percent,
            groupEmail,
            registeredUsersList
          )
          return {
            ...memberValues
          }
        })
      : []

  body.GroupInvoice = groupBodyRows
  body.WorkShiftDetails = [
    {
      WorkShiftItemId: formValues.workshift_itemid
    }
  ]

  let nestedBody
  if (!!invoice_id) {
    body.invoice_id = invoice_id
    nestedBody = nestProperties(body, 'Invoice', [
      'description',
      'invoice_id',
      'invoice_reference',
      'billing_date',
      'due_date',
      'overdue',
      'invoice_price_selection',
      'total_sum',
      'instant_payment',
      'isPaymentControl',
      'vat_select',
      'building_service',
      'status',
      'sended_by',
      'userEmail',
      'rows',
      'GroupInvoice',
      'invoice_lang',
      'document',
      'workshiftjournal', // temporary fix for invoice sending
      'agreementDetails',
      'WorkShiftDetails'
    ])
  } else {
    nestedBody = nestProperties(body, 'Invoice', [
      'description',
      'invoice_reference',
      'billing_date',
      'due_date',
      'overdue',
      'invoice_price_selection',
      'total_sum',
      'instant_payment',
      'isPaymentControl',
      'vat_select',
      'building_service',
      'status',
      'sended_by',
      'userEmail',
      'rows',
      'GroupInvoice',
      'invoice_lang',
      'document',
      'workshiftjournal', // temporary fix for invoice sending
      'agreementDetails',
      'WorkShiftDetails'
    ])
  }
  return nestedBody
}

const calculateMemberValues = (
  groupAmount,
  max_vat_percent,
  groupEmail,
  registeredUsersList
) => {
  let sumWithoutVatValue =
    Math.round((groupAmount / (1 + max_vat_percent / 100)) * 100) / 100
  if (isNaN(sumWithoutVatValue)) sumWithoutVatValue = 0

  let member_vat = groupAmount - sumWithoutVatValue

  // Find the corresponding member_uuid based on groupEmail in registeredUsersList
  const matchingUser = registeredUsersList.find(
    (user) => user.email === groupEmail
  )
  const member_uuid = matchingUser ? matchingUser.uuid : null

  return {
    member_uuid,
    member_sum_tax_free: sumWithoutVatValue,
    member_vat: member_vat
  }
}

export const convertGroupInvoiceRowValues = (
  GroupInvoiceRows,
  registeredUsersList
) => {
  return GroupInvoiceRows.map((row) => {
    const matchingUser = registeredUsersList.find(
      (user) =>
        String(user.uuid).toLowerCase() ===
        String(row.member_uuid).toLowerCase()
    )

    return {
      groupEmail: matchingUser ? matchingUser.email : '',
      groupAmount: row.member_sum_tax_free + row.member_vat
    }
  })
}
